module.exports = __webpack_public_path__ + "assets/images/project/satellite-images/nusajaya-2018-desktop.jpg?v=89961dd3";